import './Main.scss';
import 'jquery';
import '../JavaScript';